import * as types from './mutation-types'
import * as globalTypes from '../../mutation-types'
import notificationAPI from '../../../api/notifications.js'

export const getAllNotifications = ({commit}) => {
	notificationAPI.getAll()
		.then((response) => {
      if (response.data.status === "Success") {
        commit(types.NOTIFICATIONS_GET_ALL, response.data.data)
      }
      else {
        //show Error
         var error = {
            title: 'Error',
            message: 'ERROR',
            type: 'error'
        }
        commit(globalTypes.NOTIFY_ERRORS, error)
      }
		})
}

export const setSelectedNotification = ({ commit }, notification) => {
  commit(types.SET_SELECTED_NOTIFICATION, notification)
};

export const setSelectedNotificationAdmin = ({ commit }, notification) => {
  commit(types.SET_SELECTED_NOTIFICATION_ADMIN, notification)
};

export const setAkcknowledged = ({ commit }, notification) => {
  commit(types.SET_ACKKNOWLEDGE, notification)
}

export const saveNotification = ({ commit }, n) => {
  return notificationAPI.save(n)
    .then((response) => {
      if (response.data.status === "Success") {
        // commit(types.SAVE_NOTIFICATION, n)
      }
      else {
        //show Error
         var error = {
            title: 'Error',
            message: (response.data.data[0] || response.data.data).message,
            type: 'error'
        }
        commit(globalTypes.NOTIFY_ERRORS, error)
      }
      return response
    })

}



// WEBPACK FOOTER //
// ./src/store/modules/notifications/actions.js